//src/components/SuppliersPage/SupplierFormModal.jsx

import React from "react";
import Modal from "../UI/Modal";
import Button from "../UI/Button";
import { useTranslation } from "react-i18next";



const SupplierFormModal = ({
  modalOpen,
  editId,
  form,
  setForm,
  citySearch,
  setCitySearch,
  filteredCities,
  selectCity,
  save,
  closeModal,
  cityOpen,
  setCityOpen,
}) => {
  const updateField = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

const { t } = useTranslation("SuppliersPage");

  return (
    <Modal
      isOpen={modalOpen}
      onClose={closeModal}
      title={editId ? t("edit_supplier") : t("create_supplier")}
    >
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          save();
        }}
      >
        {/* NAME */}
        <input
          className="w-full border p-2 rounded-xl"
          placeholder={t("supplier_name")}
          value={form.name}
          onChange={(e) => updateField("name", e.target.value)}
        />

        {/* CONTACTS */}
        <input
          className="w-full border p-2 rounded-xl"
          placeholder={t("contacts")}
          value={form.contacts}
          onChange={(e) => updateField("contacts", e.target.value)}
        />

        {/* COMMENT */}
        <input
          className="w-full border p-2 rounded-xl"
          placeholder={t("comment")}
          value={form.comment}
          onChange={(e) => updateField("comment", e.target.value)}
        />

        {/* CERTIFICATES */}
        <input
          className="w-full border p-2 rounded-xl"
          placeholder={t("certificates")}
          value={form.certificates}
          onChange={(e) => updateField("certificates", e.target.value)}
        />

        {/* DELIVERY TERMS */}
        <input
          className="w-full border p-2 rounded-xl"
          placeholder={t("delivery_terms")}
          value={form.delivery_terms}
          onChange={(e) => updateField("delivery_terms", e.target.value)}
        />

        {/* WAREHOUSES */}
        <input
          className="w-full border p-2 rounded-xl"
          placeholder={t("warehouses")}
          value={form.warehouses}
          onChange={(e) => updateField("warehouses", e.target.value)}
        />

        {/* CITY SEARCH */}
        <div className="relative">
          <input
            className="w-full border p-2 rounded-xl"
            placeholder={t("city")}
            value={citySearch}
            onChange={(e) => {
              setCitySearch(e.target.value);
              setCityOpen(true);
            }}
            onFocus={() => setCityOpen(true)}
          />

          {cityOpen && citySearch && filteredCities.length > 0 && (
            <div className="absolute z-50 w-full bg-white border rounded-xl max-h-40 overflow-auto shadow-lg">
              {filteredCities.map((c) => (
                <div
                  key={c.id}
                  className="p-2 hover:bg-gray-100 cursor-pointer"
                  onMouseDown={() => selectCity(c)}
                >
                  {c.name}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* BUTTONS */}
        <div className="flex gap-2 pt-2">
          <Button
            type="button"
            variant="secondary"
            className="w-full"
            onClick={closeModal}
          >
            {t("cancel")}
          </Button>

          <Button type="submit" variant="primary" className="w-full">
            {editId ? t("save") : t("create")}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default SupplierFormModal;